module.exports = __webpack_public_path__ + "static/media/15UN-Habitat13.c33e12ee.jpg";